import React from 'react';

export default function NosServicesSkeleton() {
  return (
    <div className="w-full animate-pulse flex flex-col mt-10">
      <div className="h-12 bg-gray-200 w-2/3 md:w-1/3 rounded mb-8 ml-6" />
      <div className="flex flex-col md:flex-row gap-4 px-6 w-full h-[35rem] md:h-[40rem]">
        <div className="w-full md:w-1/3 h-full bg-gray-200 rounded" />
        <div className="w-full md:w-2/3 flex flex-col gap-2 h-full">
            <div className="flex-1 bg-gray-200 rounded" />
            <div className="flex-1 bg-gray-200 rounded" />
            <div className="flex-1 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
}
